module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"About {0}","vulnerability_donut":{"title":"Today\u0027s issue in this category","xAxis_label":"Month","yAxis_label":"Risk"}},"nl":{"title":"Over {0}"}}')
  delete Component.options._Ctor
}
